const BASE_URL = process.env.REACT_APP_SERVER_URL;

module.exports = {
  BASE_URL,

  USER: {
    LOGIN: "auth/login",
    REGISTER: "auth/register",
    SEND_OTP: "auth/send-otp",
    UPDATE_PROFILE: "users",
  },

  ARTIST: {
    GET_BY_ARTIST_ID: "artists",
    LIST_ARTISTS: "artists",
    LIST_FEATURED_ARTISTS: "artists/featured",
  },

  COLLECTION: {
    ADD_COLLECTION: "collections",
    LIST_COLLECTIONS: "collections",
    GET_COLLECTION_DETAIL: "collections",
    UPDATE_COLLECTION: "collections",
    LIST_FEATURED_COLLECTIONS: "collections/featured",
  },

  ART: {
    ADD_ART: "arts",
    LIST_ARTS: "arts",
    GET_ART_DETAIL: "arts",
    UPDATE_ART: "arts",
    LIST_FEATURED_ARTS: "arts/featured",
  },

  TAGS: {
    LIST_TAGS: "tags",
  },

  INQUIRIES: {
    ADD_INQUIRY: "inquires",
  },

  LICENSE_TYPES: {
    LIST_LICENSE_TYPES: "license-types",
  },

  LICENSE: {
    LIST_TERRITORIES: "licenses/territories",
    LIST_TERMS: "licenses/terms",
  },

  CATEGORIES: {
    LIST_PRODUCT_CATEGORIES: "categories",
  },

  CMS: {
    TEMPLATES: "cmstemplates",
  },
};
